import { FC } from 'react'
import _ from 'lodash'
import { CarrierDocuments } from 'views/pages/LogisticsKR/CarriersKR/CarrierKRDetails/CarrierAccordion/CarrierDocuments/CarrierDocuments'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { DocumentFile } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'

type Props = {
  carrierId: string
}
export const CarrierDocWrapper: FC<Props> = ({ carrierId }) => {
  const [progress, documents = [], documentsRefetch] = useSingleEntity<DocumentFile[]>(
    endpoints.LogisticsKR.carrierDocuments(carrierId.toString()),
  )
  return (
    <CarrierDocuments
      carrierId={carrierId}
      documentsRefetch={documentsRefetch}
      documentsProgress={progress}
      documents={documents}
    />
  )
}
